import { render, staticRenderFns } from "./slide.vue?vue&type=template&id=cc520192"
import script from "./slide.vue?vue&type=script&lang=js"
export * from "./slide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc520192')) {
      api.createRecord('cc520192', component.options)
    } else {
      api.reload('cc520192', component.options)
    }
    module.hot.accept("./slide.vue?vue&type=template&id=cc520192", function () {
      api.rerender('cc520192', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/common/components/awesome-swiper/slide.vue"
export default component.exports